import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: LoggedInUserState = {
  loggedInUser: {} as ILoggedInUser
};

interface IRole
{
  name: string
}

export interface ILoggedInUser {
  id:string,
  accountId: string,
  firstName:string,
  surname:string,
  email:string,
  country: string,
  suburb: string,
  state: string,
  postcode: string,
  phone: string,
  pin: string,
  createdAt: Date,
  roles: IRole[],
  widgetVersion: number,
};

export interface LoggedInUserState {
  loggedInUser: ILoggedInUser
}

export const loginUserSlice = createSlice({
  name: 'loggedInUser',
  initialState,
  reducers: {
    setLoggedInUser: (state, action: PayloadAction<ILoggedInUser>) => {
      return {
        ...state,
        loggedInUser: action.payload
      };
    },
    removeLoggedInUser: (state, action: PayloadAction<ILoggedInUser>) => {
      return {
        ...state,
        loggedInUser: initialState.loggedInUser
      };
    }
  }
});

export const { setLoggedInUser, removeLoggedInUser } = loginUserSlice.actions;

export default loginUserSlice.reducer;